import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Store } from 'redux/store';
import { maintenanceActions } from 'redux/maintenance';

function useMaintenance() {
  const { maintenanceFlg } = useSelector((store: Store) => store.maintenance);
  const dispatch = useDispatch();

  const clearMaintenanceFlags = useCallback(() => {
    dispatch(maintenanceActions.clearMaintenanceFlags());
    // 監視する必要のある変数が存在しないため初回のみ作成
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    maintenanceFlg,
    clearMaintenanceFlags,
  };
}

export default useMaintenance;
